import { ref, toRef, watch } from 'vue'
import { useEditSetData } from './useEditSetData'
import { useEditSetSteps } from './useEditSetSteps'
import useCheckScreen from '@/composables/useCheckScreen.js'
import {
    editAndReviewSetModalStyles,
    mobileEditAndReviewStyles,
    tableteditAndReviewSetModalStyles
} from '@/components/booking-manager/booking-part/advanced-artist/edit-set/styles'

export const useEditSet = (props, { emit }) => {
    const mode = toRef(props, 'mode')
    const set = toRef(props, 'set')
    const show = toRef(props, 'show')

    const { isMobile, isTablet } = useCheckScreen()
    const { hasError, handleError, editData, updateSetDetails, updateSetPayout } = useEditSetData(mode, set, emit)
    const { currentStep, findStep, updateStep } = useEditSetSteps(mode)
    watch(
        () => set.value,
        (set) => {
            const firstStep = findStep('initial')

            firstStep.set = set
            editData.value.id = set.eventId
            editData.value.artistId = set.artistId
            editData.value.venueId = set.venueId
        }
    )

    const openModal = ref(show.value)
    watch(
        () => show.value,
        (show) => {
            openModal.value = show
        }
    )
    watch(
        () => openModal.value,
        (openModal) => {
            emit('update:show', openModal)
        }
    )

    const modalStyles = ref({ modalWrapper: null })
    watch(
        [() => isMobile.value, () => isTablet.value],
        ([isMobile, isTablet]) => {
            if (isMobile) {
                modalStyles.value = mobileEditAndReviewStyles
            } else if (isTablet) {
                modalStyles.value = tableteditAndReviewSetModalStyles
            } else {
                modalStyles.value = editAndReviewSetModalStyles
            }
        },
        { immediate: true }
    )
    const onCtaClicked = async () => {
        if (currentStep.value.identifier.includes('initial')) {
            await editSet()
            updateStep('success')
        } else {
            openModal.value = false
            updateStep('initial')
        }
    }
    const editSet = async () => {
        switch (mode.value) {
            case 'details':
                return await updateSetDetails()
            case 'payout':
                return await updateSetPayout()
            default:
                throw new Error('Invalid mode')
        }
    }
    return {
        modalStyles,
        hasError,
        editData,
        openModal,
        currentStep,
        handleError,
        onCtaClicked
    }
}
